<template>
  <div>
    <div class="bg-black overflow-auto relative">
      <img
        class="hidden sm:block minimunHeight w-full h-full opacity-50 bg-fixed object-cover"
        src="https://homesby360.s3.amazonaws.com/Bios/Background6.jpeg"
        alt="welcome image"
      />

      <img
        class="block sm:hidden mobileMinimunHeight w-full h-full opacity-50 bg-fixed object-cover"
        src="https://homesby360.s3.amazonaws.com/Bios/Background6.jpeg"
        alt="welcome image"
      />

      <div class="absolute inset-x-0 sm:top-24 top-14">
        <section
          class="flex justify-around  content-center align-center jumbotron-fluid p-b-3 text-center"
        >
          <div class="-mt-4 sm:-mt-0 p-2 py-12 sm:py-0">
            <h1 class="text-4xl sm:text-7xl text-white font-bold uppercase">
              Welcome to <br />
              360 Real Estate!
            </h1>
            <p class="mt-2 text-base sm:text-xl text-gray-100">
              If you are ready to start working with us click on one of our
              Service cards below.<br />
              Or browse through our website and see why we proudly boast a 95%
              customer retention rate.
              <br /><br />

              <span class="hidden sm:inline">
                Buying, Property Management, Listings and Commercial Services.
                <br />
                Providing services locally for 8+ years! Our team thrives with
                local area expertise
              </span>
            </p>
            <div class="-mt-8 sm:-mt-0">
              <button
                @click="openModal"
                type="button"
                class="inline-flex uppercase items-center px-6 py-2.5 border-solid border-2 border-indigo-900 text-base font-medium rounded-md shadow-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
              >
                <i class="text-white fas fa-search mr-1"></i> Search for Homes
              </button>
            </div>
          </div>

          <div
            v-show="reviews.length > 0"
            class="hidden md:block bg-gray-50 bg-opacity-10 p-2 rounded-lg"
          >
            <sequential-entrance fromRight>
              <v-card
                max-width="600"
                color="#263238"
                dark
                outlined
                class="mx-auto"
                elevation="24"
              >
                <v-carousel
                  :continuous="true"
                  :cycle="true"
                  :show-arrows="false"
                  hide-delimiter-background
                  delimiter-icon="mdi-minus"
                  height="auto"
                >
                  <v-carousel-item
                    v-for="(review, i) in filterReviews"
                    :key="i"
                  >
                    <div
                      class="p-3 bg-gradient-to-r from-gray-800 via-gray-900 to-black"
                    >
                      <div
                        class="absolute inset-0 opacity-90 mix-blend-multiply"
                      >
                        <img
                          v-if="review.image_url"
                          :src="review.image_url"
                          alt=""
                          class="w-full h-full object-cover"
                        />
                        <img
                          v-else
                          src="https://homemanagerfortesting.s3.amazonaws.com/logo360.png"
                          alt=""
                          class="w-full h-full object-cover"
                        />
                      </div>
                      <div class="relative">
                        <!-- <img
                                  class="h-12 w-auto"
                                  src="https://homemanagerfortesting.s3.amazonaws.com/logo360.png"
                                  alt=""
                                /> -->
                        <blockquote class="mt-2 text-white">
                          <svg
                            class="h-12 w-12 text-indigo-500 opacity-50"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                            aria-hidden="true"
                          >
                            <path
                              d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                            />
                          </svg>
                          <div class="descinline text-base font-medium ">
                            {{ review.review | shortText(400) }}
                            <a
                              class="linkCustom"
                              v-if="review.review.length >= 300"
                              @click="toggler(review)"
                              ><span class="text-white -ml-2">...</span>
                              Continue reading
                            </a>
                          </div>
                          <footer class="mt-6">
                            <p
                              class="text-indigo-400 flex flex-col font-medium"
                            >
                              <span>{{ review.name }}</span>
                            </p>
                          </footer>
                        </blockquote>
                      </div>
                    </div>
                  </v-carousel-item>
                </v-carousel>
              </v-card>
            </sequential-entrance>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reviews"],

  computed: {
    filterReviews() {
      return this.reviews.filter(val => {
        return val.review !== null;
      });
    }
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  methods: {
    singleReview(value) {
      this.$router.push({ name: "Reviews", params: { id: value } });
    },

    openModal() {
      this.$emit("openModal");
    },

    openContact() {
      this.$router.push({ name: "Contact" });
    }
  }
};
</script>
